import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";

export default function SubscriptionAlert({ open, onClose }) {
  //   const [open, setOpen] = useState(false);

  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Unlock Ingredients</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Subscribe now to access all ingredients in our database. Upgrade today
          for an enhanced user experience.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="success" onClick={onClose}>
          Not Now
        </Button>
        <Button variant="contained" color="success" onClick={onClose} autoFocus>
          Subscribe
        </Button>
      </DialogActions>
    </Dialog>
  );
}
